export const Languages = {
  EN: "en", // Английский
  BN: "bn", // Бенгальский
  RU: "ru", // Русский
  TR: "tr", // Турецкий
  UZ: "uz", // Узбекский
  KZ: "kz", // Казахстанский
  AZ: "az", // Азербайджанский
  PT: "pt", // Португальский
  MM: "mm", // Бирманский
  SI: "si", // Сингальский
  FR: "fr", // Французский
  NE: "ne", // Непальский
  VI: "vi", // Вьетнамский
  KO: "ko", // Корейский
} as const;

export const Locales = {
  [Languages.EN]: "en-BD",
  [Languages.BN]: "bn",
  [Languages.RU]: "ru",
  [Languages.TR]: "tr",
  [Languages.UZ]: "uz",
  [Languages.KZ]: "kz",
  [Languages.AZ]: "az",
  [Languages.PT]: "pt-BR",
  [Languages.MM]: "mm",
  [Languages.SI]: "si",
  [Languages.FR]: "fr",
  [Languages.NE]: "ne",
  [Languages.VI]: "vi",
  [Languages.KO]: "ko",
} as const;

export const Geos = {
  "/": "Bangladesh",
  [Languages.EN]: "Bangladesh",
  [Languages.BN]: "Bangladesh",
  [Languages.RU]: "Russia",
  [Languages.TR]: "Türkiye",
  [Languages.UZ]: "Uzbekistan",
  [Languages.KZ]: "Kazakhstan",
  [Languages.AZ]: "Azerbaijan",
  [Languages.PT]: "Brazil",
  [Languages.MM]: "Bangladesh",
  [Languages.SI]: "Bangladesh",
  [Languages.NE]: "Nepali",
  [Languages.VI]: "Vietnamese",
  [Languages.KO]: "Korean",
};
